export const WhatsAppEvent = {
  QRCODE_UPDATED: 'whatsapp.qrcode.updated',
  MESSAGES_SET: 'whatsapp.messages.set',
  MESSAGES_UPSERT: 'whatsapp.messages.upsert',
  MESSAGES_UPDATE: 'whatsapp.messages.update',
  MESSAGES_DELETE: 'whatsapp.messages.delete',
  SEND_MESSAGE: 'whatsapp.send.message',
  CONTACTS_SET: 'whatsapp.contacts.set',
  CONTACTS_UPSERT: 'whatsapp.contacts.upsert',
  CONTACTS_UPDATE: 'whatsapp.contacts.update',
  PRESENCE_UPDATE: 'whatsapp.presence.update',
  CHATS_SET: 'whatsapp.chats.set',
  CHATS_UPSERT: 'whatsapp.chats.upsert',
  CHATS_UPDATE: 'whatsapp.chats.update',
  CHATS_DELETE: 'whatsapp.chats.delete',
  GROUPS_UPSERT: 'whatsapp.groups.upsert',
  GROUP_UPDATE: 'whatsapp.groups.update',
  GROUP_PARTICIPANTS_UPDATE: 'whatsapp.groups.participants.update',
  CONNECTION_UPDATE: 'whatsapp.connection.update',
  LABELS_EDIT: 'whatsapp.labels.edit',
  LABELS_ASSOCIATION: 'whatsapp.labels.association',
  CALL: 'whatsapp.call',
} as const;

export type WhatsAppEvent = (typeof WhatsAppEvent)[keyof typeof WhatsAppEvent];
